import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { authConfig } from 'src/config';
import { access_token } from './auth';

//Basic Token 생성
const clientID = authConfig.clientID;
const clientSecret = authConfig.clientSecret;
const clientCredentialBase64 = () => {
  try {
    return window.btoa(`${clientID}:${clientSecret}`);
  } catch (err) {
    return Buffer.from(`${clientID}:${clientSecret}`).toString('base64');
  }
};

//axios 설정
const config = {
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 3000,
  validateStatus: (status: number) => {
    return status < 400;
  },
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
    accept: 'application/json'
  }
};
const instance = axios.create(config);

/*
 * axios request interseptor 설정
 */
instance.interceptors.request.use(
  function (config) {
    const accessToken = localStorage.getItem(authConfig.accessTokenKey!);
    const basicAuth = new RegExp(['/login', '/access-token'].join('|'));
    const isFileUrl = !!config.url?.match(process.env.REACT_APP_CDN_URL!);
    const url = config.url;

    if (accessToken && !url?.match(basicAuth)) {
      if (!isFileUrl) config.headers!.Authorization = `Bearer ${accessToken}`;
    } else {
      config.headers!.Authorization = `Basic ${clientCredentialBase64()}`;
      config.headers!['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

/*
 * axios response interseptor 설정
 */
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const refreshToken = localStorage.getItem(authConfig.refreshTokenKey!);
    const { response } = error;
    const originRequest = error.config;
    const exception = response.data.exception;

    // accessToken expired의 경우만 실행
    if (
      exception.statusCode === 401 &&
      exception.error === '0004' && //code로 변경
      refreshToken
    ) {
      try {
        const tokenRefresh = await access_token({
          refreshToken,
          grant_type: 'refresh'
        });

        const new_acc = tokenRefresh.data.result.accessToken;
        const new_ref = tokenRefresh.data.result.refreshToken;
        localStorage.setItem(authConfig.accessTokenKey!, new_acc);
        localStorage.setItem(authConfig.refreshTokenKey!, new_ref);

        return instance(originRequest);
      } catch (e) {
        removeTokenInfo();
      }
    }

    return Promise.reject(error);
  }
);

export const get = async <T>(
  url: string,
  config?: AxiosRequestConfig<any> | undefined
): Promise<AxiosResponse<T>> => await instance.get(url, config);

export const post = async <T>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig<any> | undefined
): Promise<AxiosResponse<T>> => await instance.post(url, data, config);

export const put = async <T>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig<any> | undefined
): Promise<AxiosResponse<T>> => await instance.put(url, data, config);

export const del = async <T>(
  url: string,
  config?: AxiosRequestConfig<any> | undefined
): Promise<AxiosResponse<T>> => await instance.delete(url, config);

export const removeTokenInfo = () => {
  localStorage.removeItem(authConfig.userInfo!);
  localStorage.removeItem(authConfig.accessTokenKey!);
  localStorage.removeItem(authConfig.refreshTokenKey!);
  window.location.href = `${process.env.REACT_APP_BASE_URL}/login`;
  alert('로그인 시간이 만료되어 자동 로그아웃 됩니다.');
};

export enum FETCH_STATE {
  IDLE = 'IDLE',
  PENDING = 'PENDING'
}
